var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { CONSTRAINT_FIELD_ENDPOINT, DIGI_FORM_ASSETS_PATH, Schema, USER_PROFILE_VERSION } from '../config/config';
/**
 * Get form schema configuration
 * @param serviceName
 * @param formData
 */
export var getFormConfigData = function (serviceName, formData) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, dataSchema, uiSchema, constraints, dataSchemaItems, newDataSchema, newUiSchemaGroups;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    getSchema(serviceName, Schema.DATA_SCHEMA_FILE),
                    getSchema(serviceName, Schema.UI_SCHEMA_FILE),
                    getConstraint(),
                ])];
            case 1:
                _a = _b.sent(), dataSchema = _a[0], uiSchema = _a[1], constraints = _a[2];
                if (!constraints) {
                    throw Error('No constraints founded');
                }
                dataSchemaItems = buildDataSchema(constraints, dataSchema.properties, formData);
                newDataSchema = __assign(__assign({}, dataSchema), { properties: __assign(__assign({}, dataSchema.properties), { diploma: __assign(__assign({}, dataSchema.properties.diploma), { items: dataSchemaItems.diploma }), domain: __assign(__assign({}, dataSchema.properties.domain), { items: dataSchemaItems.domain }), level: __assign(__assign({}, dataSchema.properties.level), { items: dataSchemaItems.level }), sector: __assign(__assign({}, dataSchema.properties.sector), { items: dataSchemaItems.sector }), speciality: __assign(__assign({}, dataSchema.properties.speciality), { items: dataSchemaItems.speciality }), status: __assign(__assign({}, dataSchema.properties.status), { items: dataSchemaItems.status }) }) });
                newUiSchemaGroups = buildUiSchema(constraints, uiSchema.groups, newDataSchema, formData);
                return [2 /*return*/, [newDataSchema, __assign(__assign({}, uiSchema), { groups: newUiSchemaGroups })]];
        }
    });
}); };
export var getLevelConstraintVisibility = function (condition, constraints, dataSchema) {
    var statusListWithLevel = constraints.statuses.filter(function (status) { return status.levels.length; });
    return {
        filters: constraints.statuses.filter(function (status) { return status.levels.length; })
            .map(function (status) { return ({ status: status.slug }); }),
        index: constraints.statuses.filter(function (status) { return status.levels.length; })
            .map(function (status) {
            return status.levels.map(function (level) {
                return dataSchema.properties.level.items.findIndex(function (item) { return level.slug === item; });
            });
        }),
        requiredFieldsValues: statusListWithLevel.map(function (status) {
            return { status: status.slug };
        }),
    };
};
export var getSectorConstraintVisibility = function (condition, constraints, dataSchema) {
    var domainListWithSector = constraints.domains.filter(function (domain) { return domain.sectors.length; });
    return {
        filters: constraints.domains.filter(function (domain) { return domain.sectors.length; })
            .map(function (domain) { return ({ domain: domain.slug }); }),
        index: constraints.domains.filter(function (domain) { return domain.sectors.length; })
            .map(function (domain) {
            return domain.sectors.map(function (sector) {
                return dataSchema.properties.sector.items.findIndex(function (item) { return sector.slug === item; });
            });
        }),
        requiredFieldsValues: domainListWithSector.map(function (domain) {
            return { domain: domain.slug };
        }),
    };
};
export var getDiplomaConstraintVisibility = function (condition, constraints, dataSchema) {
    return {
        requiredFieldsValues: constraints.statuses.map(function (status) {
            var levelList = status.levels.filter(function (level) { return level.diplomas.length; });
            return levelList.map(function (level) {
                return { level: level.slug };
            });
        })
            .filter(function (data) { return data; })
            .reduce(function (prev, curr) { return __spreadArrays(prev, curr); }, []),
        filters: constraints.statuses.map(function (status) {
            var levelList = status.levels.filter(function (level) { return level.diplomas.length; });
            return levelList.map(function (level) {
                return { level: level.slug };
            });
        })
            .filter(function (data) { return data; })
            .reduce(function (prev, curr) { return __spreadArrays(prev, curr); }, []),
        index: constraints.statuses.map(function (status) {
            var levelList = status.levels.filter(function (level) { return level.diplomas.length; });
            return levelList.map(function (level) {
                return level.diplomas.map(function (diploma) {
                    return dataSchema.properties.diploma.items.findIndex(function (item) { return diploma.slug === item; });
                })
                    .filter(function (index) { return (index > -1); });
            });
        })
            .filter(function (data) { return data; })
            .reduce(function (prev, curr) { return __spreadArrays(prev, curr); }, []),
    };
};
export var getSpecialityConstraintVisibility = function (condition, constraints, dataSchema) {
    return constraints.statuses.map(function (status) {
        return status.levels.map(function (level) {
            return level.diplomas
                .filter(function (diploma) { return diploma.specialities && diploma.specialities.length; })
                .map(function (diploma) {
                return ({ diploma: diploma.slug });
            });
        }).reduce(concatStringArray, []);
    }).reduce(concatStringArray, [])
        .reduce(removeDuplicate, []);
};
export var buildDataSchema = function (constraints, properties, formData) {
    var statusList = constraints.statuses
        // @ts-ignore
        .filter(function (status) { return (properties.status.items.includes(status.slug) || formData.status === status.slug); })
        .map(function (status) { return status.slug; });
    return {
        diploma: getDiplomaList(constraints.statuses, 'slug'),
        domain: getDomainList(constraints.domains, 'slug'),
        level: getLevelList(constraints.statuses, 'slug'),
        sector: getSectorList(constraints.domains, 'slug'),
        speciality: getSpecialityList(constraints.statuses, 'slug'),
        status: getStatusList(constraints.statuses, 'slug', statusList),
    };
};
export var buildUiSchema = function (constraints, groupList, dataSchema, formData) {
    var statusList = constraints.statuses
        // @ts-ignore
        .filter(function (status) { return (dataSchema.properties.status.items.includes(status.slug) || formData.status === status.slug); })
        .map(function (status) { return status.label; });
    return groupList.map(function (group) {
        var properties = __assign({}, group.properties);
        var conditions = __assign({}, group.conditions);
        var groupPropertyKeys = Object.keys(group.properties);
        if (groupPropertyKeys.includes('status')) {
            properties.status['ui:options'].listLabels = getStatusList(constraints.statuses, 'label', statusList);
        }
        if (groupPropertyKeys.includes('level')) {
            properties.level['ui:options'].listLabels = getLevelList(constraints.statuses, 'label');
            var levelConstraint_1 = getLevelConstraintVisibility(conditions.level, constraints, dataSchema);
            conditions.level.visibility = {
                requiredFieldsValues: levelConstraint_1.requiredFieldsValues,
            };
            conditions.level.filters = levelConstraint_1.filters.map(function (filter, index) {
                return { requiredFieldsValues: [filter], index: levelConstraint_1.index[index] };
            });
        }
        if (groupPropertyKeys.includes('domain')) {
            properties.domain['ui:options'].listLabels = getDomainList(constraints.domains, 'label');
        }
        if (groupPropertyKeys.includes('sector')) {
            properties.sector['ui:options'].listLabels = getSectorList(constraints.domains, 'label');
            var sectorConditions_1 = getSectorConstraintVisibility(conditions.sector, constraints, dataSchema);
            conditions.sector.visibility = {
                requiredFieldsValues: sectorConditions_1.requiredFieldsValues,
            };
            conditions.sector.filters = sectorConditions_1.filters.map(function (filter, index) {
                return { requiredFieldsValues: [filter], index: sectorConditions_1.index[index] };
            });
        }
        if (groupPropertyKeys.includes('diploma')) {
            properties.diploma['ui:options'].listLabels = getDiplomaList(constraints.statuses, 'label');
            var diplomaConstraint_1 = getDiplomaConstraintVisibility(conditions.diploma, constraints, dataSchema);
            conditions.diploma.visibility = {
                requiredFieldsValues: diplomaConstraint_1.requiredFieldsValues
            };
            conditions.diploma.filters = diplomaConstraint_1.filters.map(function (filter, index) {
                return { requiredFieldsValues: [filter], index: diplomaConstraint_1.index[index] };
            });
        }
        if (groupPropertyKeys.includes('speciality')) {
            properties.speciality['ui:options'].listLabels = getSpecialityList(constraints.statuses, 'label');
            var specialityConstraint = getSpecialityConstraintVisibility(conditions.speciality, constraints, dataSchema);
            conditions.speciality.visibility = { requiredFieldsValues: specialityConstraint };
        }
        return __assign(__assign({}, group), { conditions: conditions,
            properties: properties });
    });
};
/**
 * Get status list
 * @param constraintStatusList
 * @param type
 * @param statusList
 */
export var getStatusList = function (constraintStatusList, type, statusList) {
    return constraintStatusList.map(function (status) { return status[type]; })
        .reduce(removeDuplicate, [])
        .filter(function (status) { return statusList.includes(status); });
};
/**
 * Get level list
 * @param constraintStatusList
 * @param type
 */
export var getLevelList = function (constraintStatusList, type) {
    return constraintStatusList.map(function (status) {
        return status.levels.map(function (level) {
            return level[type];
        });
    }).reduce(concatStringArray, [])
        .reduce(removeDuplicate, []);
};
/**
 * Get diploma list
 * @param constraintStatusList
 * @param type
 */
export var getDiplomaList = function (constraintStatusList, type) {
    return constraintStatusList.map(function (status) {
        return status.levels
            .filter(function (level) { return level.diplomas && level.diplomas.length; })
            .map(function (level) {
            return level.diplomas.map(function (diploma) { return diploma[type]; });
        }).reduce(concatStringArray, []);
    }).reduce(concatStringArray, [])
        .reduce(removeDuplicate, []);
};
/**
 * Get specialityList
 * @param constraintStatusList
 * @param type
 */
export var getSpecialityList = function (constraintStatusList, type) {
    return constraintStatusList.map(function (status) {
        return status.levels.map(function (level) {
            return level.diplomas
                .filter(function (diploma) { return diploma.specialities && diploma.specialities.length; })
                .map(function (diploma) {
                return diploma.specialities.map(function (speciality) { return speciality[type]; });
            }).reduce(concatStringArray, []);
        }).reduce(concatStringArray, []);
    }).reduce(concatStringArray, [])
        .reduce(removeDuplicate, []);
};
/**
 * Get domain list
 * @param constraintDomainList
 * @param type
 */
export var getDomainList = function (constraintDomainList, type) {
    return constraintDomainList.map(function (domain) { return domain[type]; })
        .reduce(removeDuplicate, []);
};
/**
 * Get sector list
 * @param constraintDomainList
 * @param type
 */
export var getSectorList = function (constraintDomainList, type) {
    return constraintDomainList.map(function (domain) {
        return domain.sectors.map(function (sector) {
            return sector[type];
        });
    }).reduce(concatStringArray, [])
        .reduce(removeDuplicate, []);
};
/**
 * Get lilsis constraints
 */
export var getConstraint = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch(CONSTRAINT_FIELD_ENDPOINT, { headers: { 'X-DigiSchool-Situation-Version': USER_PROFILE_VERSION } })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                throw Error(error_1);
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Concat string array
 * @param previousValue
 * @param currentValue
 */
var concatStringArray = function (previousValue, currentValue) {
    return (__spreadArrays(previousValue, currentValue));
};
/**
 * Remove duplicate value from array
 * @param unique
 * @param item
 */
var removeDuplicate = function (unique, item) {
    return unique.includes(item) ? unique : __spreadArrays(unique, [item]);
};
/**
 * Get schema data
 * @param serviceName
 * @param schema
 */
var getSchema = function (serviceName, schema) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(getSchemaUrl(serviceName, schema), { mode: 'cors' })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw Error(response.status + " " + response.statusText);
                }
                return [2 /*return*/, response.json()];
            case 2:
                error_2 = _a.sent();
                throw Error(error_2);
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Get schema url
 * @param serviceName
 * @param schema
 */
var getSchemaUrl = function (serviceName, schema) {
    return DIGI_FORM_ASSETS_PATH + "/" + schema + "." + serviceName + ".json";
};
//# sourceMappingURL=digiUserProfile.service.js.map